import { Locales } from '@griply/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { completeSignupAndLogin } from 'shared/services/backend-api';
import { AuthFlowError } from 'shared/types/auth-flow-error';
import { ResetPasswordErrorTypes } from 'shared/types/reset-password-form';
import { User } from 'shared/types/user';

import { queryKey as useUserKey } from './use-user-query';

export const useCompleteSignupAndLoginMutation = () => {
  const client = useQueryClient();

  return useMutation<
    User | null,
    AuthFlowError<ResetPasswordErrorTypes>,
    {
      password: string;
      claimToken: string;
      name?: string;
      locale?: Locales;
    }
  >({
    mutationFn: async ({ password, claimToken, name, locale }) => {
      const user = await completeSignupAndLogin(claimToken, password, {
        name,
        locale,
      });

      await client.invalidateQueries({ queryKey: [useUserKey] });

      return user;
    },
  });
};
